// Mock data for Railway Machines clone (frontend-only). A Garry Industries venture.

export const IMG = {
  heroHome: "https://images.pexels.com/photos/8584622/pexels-photo-8584622.jpeg",
  railYard: "https://images.pexels.com/photos/5821600/pexels-photo-5821600.jpeg",
  goldenHour: "https://images.unsplash.com/photo-1568820577012-d581e7debd21",
  excavator: "https://images.unsplash.com/photo-1580901369227-308f6f40bdeb",
  tamping: "https://images.pexels.com/photos/20732856/pexels-photo-20732856.jpeg",
  trolley: "https://images.pexels.com/photos/38886906/pexels-photo-38886906.jpeg",
  yellowMachine: "https://images.unsplash.com/photo-1767387380270-9b80ea81c275",
  workers: "https://images.unsplash.com/photo-1684869293922-d82a3515072b",
  gears: "https://images.unsplash.com/photo-1524514587686-e2909d726e9b",
  robotWheels: "https://images.unsplash.com/photo-1722413891611-a3d5b739aac0",
  robotDog: "https://images.pexels.com/photos/19319639/pexels-photo-19319639.jpeg",
  robotArm: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b",
  robotArm2: "https://images.pexels.com/photos/8438967/pexels-photo-8438967.jpeg",
  drone: "https://images.unsplash.com/photo-1527977966376-1c8408f9f108",
  dashboard: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74",
  dataViz: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86",
  analytics: "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
  corpA: "https://images.unsplash.com/photo-1560179707-f14e90ef3623",
  corpB: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Engineering", to: "/engineering" },
  { label: "Machines", to: "/machines" },
  { label: "AI Platform", to: "/ai-platform" },
  { label: "Investors", to: "/investors" },
];

export const COMPANY_MENU = [
  { label: "About & Vision", to: "/about", desc: "Our long-term platform vision" },
  { label: "Investors", to: "/investors", desc: "The platform investment thesis" },
  { label: "Contact", to: "/contact", desc: "Start a conversation" },
];

export const HERO_STATS = [
  { value: "12+", label: "Concept platforms" },
  { value: "4", label: "Engineering domains" },
  { value: "Decade+", label: "Innovation roadmap" },
  { value: "Global", label: "Standards & ambition" },
];

export const TICKER = [
  "Track Renewal", "High-Output Tamping", "Ballast Regulation", "Rail Grinding",
  "OHE Maintenance", "Bridge Inspection", "Tunnel Robotics", "Autonomous Vehicles",
  "Digital Twin", "Predictive Maintenance",
];

export const DOMAINS = [
  { title: "Track Machinery", desc: "Renewal, tamping, ballast regulation and grinding systems for high-output maintenance.", icon: "Train" },
  { title: "Inspection & Robotics", desc: "Autonomous track, tunnel and bridge inspection with multi-sensor diagnostics.", icon: "ScanLine" },
  { title: "Autonomous Systems", desc: "Battery-electric vehicles and UAVs with machine-vision perception and remote control.", icon: "Bot" },
  { title: "Digital & AI Platform", desc: "Digital twins, predictive maintenance and fleet intelligence across the asset lifecycle.", icon: "BrainCircuit" },
];

export const CATEGORIES = ["All", "Track Machinery", "Electrification", "Inspection & Robotics", "Autonomous Systems"];

export const MACHINES = [
  { id: "track-renewal", name: "Track Renewal System", category: "Track Machinery", tagline: "Modular high-output track renewal", desc: "A modular platform that removes worn rails and sleepers while laying new components in a single continuous pass.", image: IMG.yellowMachine },
  { id: "tamping", name: "High-Output Tamping Machine", category: "Track Machinery", tagline: "Precision geometry correction at speed", desc: "Continuous-action tamping for precise track geometry correction across long working shifts.", image: IMG.tamping },
  { id: "ballast-regulator", name: "Ballast Regulating Machine", category: "Track Machinery", tagline: "Profile, sweep and distribute ballast", desc: "Profiles, sweeps and redistributes ballast to maintain an accurate track bed cross-section.", image: IMG.trolley },
  { id: "rail-grinder", name: "Rail Grinding Machine", category: "Track Machinery", tagline: "Restore rail profile, extend asset life", desc: "Restores the rail head profile and removes surface defects to extend rail asset life.", image: IMG.excavator },
  { id: "ohe-maintenance", name: "OHE Maintenance Vehicle", category: "Electrification", tagline: "Safe access to catenary systems", desc: "Provides safe, elevated access for inspection and maintenance of overhead electrification systems.", image: IMG.workers },
  { id: "bridge-inspection", name: "Bridge Inspection Vehicle", category: "Inspection & Robotics", tagline: "Robotic under-bridge inspection", desc: "An articulated robotic platform for detailed under-bridge structural inspection.", image: IMG.railYard },
  { id: "tunnel-robot", name: "Tunnel Inspection Robot", category: "Inspection & Robotics", tagline: "Autonomous confined-space inspection", desc: "Autonomous confined-space inspection with multi-sensor perception for tunnels.", image: IMG.robotWheels },
  { id: "track-robot", name: "Track Inspection Robot", category: "Inspection & Robotics", tagline: "Continuous autonomous track diagnostics", desc: "Continuous autonomous diagnostics of track geometry, fastenings and rail condition.", image: IMG.robotDog },
  { id: "sleeper-robot", name: "Sleeper Handling Robot", category: "Inspection & Robotics", tagline: "Automated sleeper placement", desc: "Robotic manipulation for automated, precise sleeper handling and placement.", image: IMG.robotArm },
  { id: "autonomous-vehicle", name: "Autonomous Maintenance Vehicle", category: "Autonomous Systems", tagline: "Battery-electric autonomous operations", desc: "A battery-electric autonomous platform for unmanned routine maintenance operations.", image: IMG.goldenHour },
  { id: "inspection-drone", name: "Corridor Inspection Drone", category: "Autonomous Systems", tagline: "Aerial railway corridor inspection", desc: "A long-endurance UAV for aerial inspection of railway corridors and infrastructure.", image: IMG.drone },
];

export const FEATURED = ["track-renewal", "rail-grinder", "bridge-inspection", "tunnel-robot", "autonomous-vehicle"];

export const PHILOSOPHY_TAGS = ["Design for service", "Safety by design", "Sensor-native", "Built to manufacture"];

export const AI_STEPS = [
  { n: "01", title: "Digital Twin", desc: "Real-time asset and network visualisation." },
  { n: "02", title: "Predictive Maintenance", desc: "Failure prediction from multi-sensor telemetry." },
  { n: "03", title: "Fleet Intelligence", desc: "Health, utilisation and diagnostics at scale." },
];

export const AI_PILLARS = [
  { title: "Digital Twin", desc: "A continuously updated virtual model of every machine and asset across the network." },
  { title: "Predictive Maintenance", desc: "Multi-sensor telemetry and ML models forecast failures before they occur." },
  { title: "Live Diagnostics", desc: "Real-time machine health, utilisation and performance dashboards." },
  { title: "Fleet Intelligence", desc: "Fleet-wide coordination, scheduling and autonomous decision support." },
];

export const AI_LAYERS = [
  { id: "L1", title: "Edge", desc: "On-machine sensing, perception and safety-critical control." },
  { id: "L2", title: "Connectivity", desc: "Secure telemetry from field machines to the platform." },
  { id: "L3", title: "Data Platform", desc: "Unified time-series, inspection and asset data lake." },
  { id: "L4", title: "Intelligence", desc: "Predictive models, anomaly detection and digital twins." },
  { id: "L5", title: "Experience", desc: "Command-centre dashboards, alerts and reporting." },
];

export const ROADMAP = [
  { n: "01", title: "Foundation", desc: "Establish the engineering core, design language and concept platform architecture." },
  { n: "02", title: "Engineering & Prototyping", desc: "Detailed design, simulation and validation of priority machine platforms." },
  { n: "03", title: "Product Families", desc: "Scale from concepts to a coordinated ecosystem of track, inspection and autonomous systems." },
  { n: "04", title: "Intelligence & Autonomy", desc: "Embed sensing, AI and the digital-twin platform across the full fleet." },
  { n: "05", title: "Global Capability", desc: "Mature manufacturing, aftermarket and export capability to global standards." },
];

export const PRINCIPLES = [
  { n: "01", title: "Engineering first", desc: "Every decision is grounded in engineering reasoning, not marketing." },
  { n: "02", title: "Built for reality", desc: "Machines conceived to be manufacturable, serviceable and durable." },
  { n: "03", title: "Intelligence by design", desc: "Sensing and data are native to every platform, not bolted on." },
  { n: "04", title: "Long-term commitment", desc: "A decades-long roadmap, not a single product cycle." },
  { n: "05", title: "Global standards", desc: "Engineered to compete with the world's finest OEMs." },
  { n: "06", title: "Indigenous capability", desc: "Strengthening India's advanced engineering and manufacturing base." },
];

export const CAPABILITIES = [
  { id: "C.01", title: "Mechanical Design", desc: "Heavy structures, bogies, chassis and hydraulic systems engineered for load and duty cycle.", icon: "Cog" },
  { id: "C.02", title: "Robotics & Manipulation", desc: "Robotic arms, manipulators and autonomous platforms for precise field operations.", icon: "Bot" },
  { id: "C.03", title: "Sensing & Perception", desc: "LiDAR, machine vision, ultrasonic and thermal sensing integrated into every machine.", icon: "Radar" },
  { id: "C.04", title: "Controls & Autonomy", desc: "Real-time control systems, obstacle detection and progressive levels of autonomy.", icon: "Cpu" },
  { id: "C.05", title: "Simulation & Digital Engineering", desc: "Model-based design, FEA and digital-twin validation before metal is cut.", icon: "Boxes" },
  { id: "C.06", title: "Systems Integration", desc: "Bringing mechanical, electrical, software and data systems into coherent products.", icon: "Combine" },
];

export const DESIGN_RULES = [
  "Correct railway wheelsets & gauge compatibility",
  "Logical bogie arrangement",
  "Operator cabin with full visibility",
  "Maintenance access & service panels",
  "Hydraulic systems & tool interfaces",
  "Battery / hybrid power provisions",
  "Sensor locations & lighting",
  "Walkways, handrails & access ladders",
  "Safety markings & emergency exits",
  "Lifting points & coupling interfaces",
];

export const INVEST_THESIS = [
  { title: "Large Addressable Market", desc: "Railway maintenance and modernisation is a vast, sustained, global infrastructure market." },
  { title: "Scalable Platform Strategy", desc: "Multiple product families built on shared engineering and digital foundations." },
  { title: "High Barriers to Entry", desc: "Deep engineering, safety and integration complexity protect defensible positions." },
  { title: "Recurring Aftermarket", desc: "Decades-long machine lifecycles generate durable spares, service and upgrade revenue." },
  { title: "Digital & Licensing Upside", desc: "Software, digital-twin subscriptions and technology licensing as scalable revenue layers." },
  { title: "Export Scalability", desc: "Engineered to global standards, with a clear path to international markets." },
];

export const PRODUCT_FAMILIES = [
  { id: "F.01", title: "Track Machinery", desc: "Renewal, tamping, ballast regulation, rail grinding." },
  { id: "F.02", title: "Inspection & Robotics", desc: "Track, tunnel and bridge inspection; sleeper handling." },
  { id: "F.03", title: "Autonomous Systems", desc: "Battery-electric vehicles and corridor inspection UAVs." },
  { id: "F.04", title: "Digital & AI Platform", desc: "Digital twin, predictive maintenance and fleet intelligence." },
];

export const ENQUIRY_TYPES = [
  "General Enquiry", "Railway Operator / Authority", "OEM / Technology Partner",
  "Investor", "Supplier / Manufacturing", "Research / University", "Media",
];

export const COMPANY = {
  name: "Railway Machines",
  parent: "Garry Industries",
  email: "railwayprojects@garryindustries.com",
  tagline: "Intelligent Railway Engineering",
  location: "Designed & engineered in India",
};
